export default __webpack_public_path__ + "static/media/151-studying.37cd777f.png";